
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/csr/society/disaster-relief",
      function () {
        return require("private-next-pages/csr/society/disaster-relief.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/csr/society/disaster-relief"])
      });
    }
  